export class EmailRequest {
	email: string;

constructor(data?: EmailRequest) {
		if (data) {
			Object.assign(this, data);
		}
	}
}
